<div class="control single-option-chooser">
  @switch (displayStyle) {
    @case ("DropDown") {
      <mat-select [(ngModel)]="selectedValue"
        (selectionChange)="selectedValueChange.emit($event.value)">
        @for (option of options; track trackByLabel($index, option)) {
          <mat-option
            [value]="option.value">
            {{option.label}}
          </mat-option>
        }
      </mat-select>
    }
    @case ("RadioButton") {
      <mat-radio-group
        (change)="selectedValueChange.emit($event.value)"
        [value]="selectedValue">
        @for (option of options; track trackByLabel($index, option)) {
          <mat-radio-button
            [value]="option.value">
            {{option.label}}
          </mat-radio-button>
        }
      </mat-radio-group>
    }
  }
</div>
